import "core-js/stable";
import Vue from "vue";
import "regenerator-runtime/runtime";
//import CoreuiVuePro from '@coreui/vue-pro'
import CoreuiVuePro from "../node_modules/@coreui/vue-pro/src/index.js";
import App from "./App";
import router from "./router/index";
import { iconsSet as icons } from "./assets/icons/icons.js";
import store from "./store/store";
import i18n from "./i18n.js";
import ip from "@/axios/index.js";
import { ipBackend } from "@/ipBackend.js";
import moment from "moment";
import "moment/locale/id";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/id";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
// import 'bootstrap/dist/css/bootstrap.css';
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-pdf-app/dist/icons/main.css";
import VueApexCharts from "vue-apexcharts";
import { BootstrapVueIcons } from 'bootstrap-vue'

Vue.use(BootstrapVueIcons)
Vue.use(CoreuiVuePro);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.component("Multiselect", Multiselect);
Vue.component("DatePicker", DatePicker);
Vue.component("apexchart", VueApexCharts);
Vue.prototype.$log = console.log.bind(console);
Vue.prototype.$axios = ip;
Vue.prototype.$be = ipBackend;
Vue.prototype.$moment = moment;

//global component
import MyPagination from "./component/pagination/pagination";
Vue.component("MyPagination", MyPagination);

//global function
import numberFormat from "./functions/numberFormat.js";
Vue.prototype.$numberFormat = numberFormat.methods.number;

function extractName(filePath) {
  return filePath
    .split("/")
    .pop()
    .replace(/\.\w+$/, "");
}

const IconModules = require.context("./component/icons", true, /\.vue$/);

IconModules.keys().forEach((filePath) => {
  const component = IconModules(filePath);
  const iconName = `${component.default?.name || extractName(filePath)}Icon`;
  // console.log(`Registering icon component: ${iconName}`);
  Vue.component(iconName, component.default || component);
});

new Vue({
  el: "#app",
  router,
  store,
  //CIcon component documentation: https://coreui.io/vue/docs/components/icon
  icons,
  i18n,
  template: "<App/>",
  components: {
    App,
  },
});
